module.exports = __webpack_public_path__ + "static/icon-e2da31fa85ef3858cfe5edbb2561cb6f.svg";